export const ROUTES = {
  DASHBOARD: "/",
  SHOPS: "/shops",
  ADMIN_MY_SHOPS: "/my-shops",
  CREATE_SHOP: "/shops/create",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  BANNERS: "/banners",
  MAIN_SLIDER: "/banners/main",
  SIDE_BANNERS: "/banners/side",
  POPUP_BANNERS: "/banners/popup",
  BRANCH: "/branch",
  DEALS: "/deals",
  ORDER_STATUS: "/order-status",
  ORDER_ATTRIBUTES: "/order-attributes",
  ORDERS: "/orders",
  ORDERS_CREATE: "/orders/create",
  ORDER_ANALYTICS: "/order-analytics",
  ORDER_ANALYTICS_EXPORT: "/order-analytics/export",
  SETTLEMENTS: "/settlements",
  PRODUCTS: "/products",
  COUPONS: "/coupons",
  VOUCHERS: "/vouchers",
  SEARCH_TERMS: "/search-terms",
  CUSTOMERS: "/customers",
  USERS: "/users",
  SYSTEM_USERS: "/users/list/system",
  CUSTOMER_USERS: "/users/list/customer",
  MEMBERSHIPS: "/memberships",
  CUSTOMER_GROUPS: "/customer_groups",
  ROLES: "/roles",
  TAXES: "/taxes",
  LOYALTY_WALLETS: "/wallets",
  DISCOUNTS: "/discounts",
  PROMOTION_DISCOUNTS: "/discounts/promotion",
  NOTIFICATION: "/notification",
  SCHEDULE_NOTIFICATION: "/schedule-notifications",
  CUSTOM_CONTENTS: "/custom-content",
  CUSTOM_CONTENTS_BLOG: "/custom-content/blog",
  CUSTOM_CONTENTS_NEWS: "/custom-content/news",
  CUSTOM_CONTENTS_GUIDE: "/custom-content/guide",
  CUSTOM_CONTENTS_CUSTOMER_STORY: "/custom-content/customer_story",
  CUSTOM_CONTENTS_FEATURED: "/custom-content/featured",
  LOCATIONS: "/locations",
  STORES: "/stores",
  SHIPPINGS: "/shippings",
  SHIPPING_ZONES: "/shipping-zones",
  SETTINGS: "/settings",
  DOMAIN_BLOCKLIST: "/domain-blocklist",
  STORE_SETTINGS: "/vendor/settings",
  STORE_KEEPER: "/vendor/store_keepers",
  CATEGORIES: "/categories",
  PAYMENT_GATEWAYS: "/payment-gateways",
  PAYMENT_METHODS: "/payment-methods",
  ATTRIBUTES: "/attributes",
  ATTRIBUTE_VALUES: "/attribute-values",
  GROUPS: "/groups",
  TAGS: "/tags",
  WITHDRAWS: "/withdraws",
  PROFILE_UPDATE: "/profile-update",
  LOGOUT: "/logout",
  STAFFS: "/staffs",
  BULK_SHIPPING_DOCUMENTS: "/bulk-shipping-documents",
  BULK_UPDATE_ORDER_STATUS: "/bulk-update-order-status",
};
